import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getSearchParams } from '../../utils/url';

/* eslint-disable react/jsx-props-no-spreading */

/**
 * Helper component to pass react router props down into children of Routes
 */
const WithSearchParams = (props) => {
  const { component: WrappedComponent } = props;
  const location = useLocation();
  const navigate = useNavigate();
  const params = getSearchParams(location.search);
  return <WrappedComponent navigate={navigate} location={location} {...props} {...params} />;
};

export default WithSearchParams;
